var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-dialog",
    {
      ref: "dialog",
      attrs: {
        color: "success",
        icon: "mdi-file-outline",
        "store-modal": "",
        title: _vm.generateMessage("requests.actions.workorder_report")
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: {
                        small: "",
                        color: "success",
                        loading: _vm.isLoading,
                        disabled: !_vm.tech || !_vm.body.state
                      },
                      on: { click: _vm.onValidate }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.generateMessage("requests.actions.validate")
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: { small: "" },
                      on: { click: _vm.cancel }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.generateMessage("requests.actions.cancel")
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c("v-select", {
            staticClass: "mx-2",
            attrs: {
              "item-text": "name",
              "item-value": "id",
              items: _vm.states,
              label: _vm.generateMessage("requests.actions.status") + " *",
              color: "success",
              outlined: "",
              dense: ""
            },
            on: {
              input: function($event) {
                return _vm.$refs.form.resetValidation()
              }
            },
            model: {
              value: _vm.body.state,
              callback: function($$v) {
                _vm.$set(_vm.body, "state", $$v)
              },
              expression: "body.state"
            }
          }),
          _vm._v(" "),
          _c("custom-technician-search-field", {
            ref: "tech",
            attrs: {
              disabled: _vm.isWaiting,
              entityId: _vm.entity_nav_full_id,
              "property-id": _vm.propertyId,
              request: _vm.request
            },
            model: {
              value: _vm.tech,
              callback: function($$v) {
                _vm.tech = $$v
              },
              expression: "tech"
            }
          }),
          _vm._v(" "),
          _c("v-autocomplete", {
            staticClass: "mx-2",
            attrs: {
              items: _vm.reasons,
              rules: [v => !!v || "Ce champ est obligatoire"],
              disabled: !_vm.isClosing,
              placeholder:
                _vm.generateMessage("requests.actions.diagnosis") + " *",
              clearable: "",
              outlined: "",
              dense: "",
              "item-text": "diagnostic_qualif_name",
              "item-value": "diagnostic_qualif_id",
              "hide-selected": "",
              color: "success"
            },
            model: {
              value: _vm.body.diagnosis,
              callback: function($$v) {
                _vm.$set(_vm.body, "diagnosis", $$v)
              },
              expression: "body.diagnosis"
            }
          }),
          _vm._v(" "),
          _c("v-autocomplete", {
            staticClass: "mx-2",
            attrs: {
              items: _vm.treatments,
              rules: [v => !!v || "Ce champ est obligatoire"],
              disabled: !_vm.isClosing,
              placeholder:
                _vm.generateMessage("requests.actions.treatment") + " *",
              clearable: "",
              outlined: "",
              dense: "",
              "item-text": "name",
              "item-value": "id",
              "hide-selected": "",
              color: "success"
            },
            model: {
              value: _vm.body.treatment_id,
              callback: function($$v) {
                _vm.$set(_vm.body, "treatment_id", $$v)
              },
              expression: "body.treatment_id"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("v-select", {
                staticClass: "mx-2",
                staticStyle: { width: "50%" },
                attrs: {
                  disabled: !_vm.isClosing,
                  "item-text": "id",
                  "item-value": "id",
                  items: _vm.services,
                  label:
                    _vm.generateMessage("requests.actions.prestation") + " *",
                  rules: [v => !!v || "Ce champ est obligatoire"],
                  color: "success",
                  clearable: "",
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _vm.body.service_id,
                  callback: function($$v) {
                    _vm.$set(_vm.body, "service_id", $$v)
                  },
                  expression: "body.service_id"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "mx-2",
                staticStyle: { width: "50%" },
                attrs: {
                  label: _vm.generateMessage("requests.actions.team_number"),
                  disabled: !_vm.isClosing,
                  outlined: "",
                  rules: [v => v.length <= 15 || "Maximum 15 caractères."],
                  color: "success"
                },
                model: {
                  value: _vm.body.equipment_number,
                  callback: function($$v) {
                    _vm.$set(_vm.body, "equipment_number", $$v)
                  },
                  expression: "body.equipment_number"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("v-text-field", {
                staticClass: "mx-2",
                staticStyle: { width: "50%" },
                attrs: {
                  label:
                    _vm.generateMessage("requests.actions.begin_datetime") +
                    " *",
                  color: "success",
                  disabled: !_vm.isClosing,
                  outlined: "",
                  rules: [
                    v => !!v || "Ce champ est obligatoire",
                    v =>
                      v < _vm.formatDateToInput(new Date()) ||
                      "La date ne doit pas être dans le futur"
                  ],
                  type: "datetime-local"
                },
                on: { input: _vm.updateDuration },
                model: {
                  value: _vm.body.intervention_start_datetime,
                  callback: function($$v) {
                    _vm.$set(_vm.body, "intervention_start_datetime", $$v)
                  },
                  expression: "body.intervention_start_datetime"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "mx-2",
                staticStyle: { width: "50%" },
                attrs: {
                  label:
                    _vm.generateMessage("requests.actions.end_datetime") + " *",
                  disabled: !_vm.isClosing,
                  outlined: "",
                  rules: [
                    v => !!v || "Ce champ est obligatoire",
                    v =>
                      this.body.intervention_start_datetime < v ||
                      "Les dates doivent correspondre",
                    v =>
                      v < _vm.formatDateToInput(new Date()) ||
                      "La date ne doit pas être dans le futur"
                  ],
                  color: "success",
                  type: "datetime-local"
                },
                on: { input: _vm.updateDuration },
                model: {
                  value: _vm.body.intervention_end_datetime,
                  callback: function($$v) {
                    _vm.$set(_vm.body, "intervention_end_datetime", $$v)
                  },
                  expression: "body.intervention_end_datetime"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("v-text-field", {
                staticClass: "mx-2",
                staticStyle: { width: "50%" },
                attrs: {
                  label: _vm.generateMessage("requests.actions.duration"),
                  disabled: !_vm.isClosing,
                  rules: [v => !!v || ""],
                  outlined: "",
                  readonly: "",
                  value: _vm._f("displayDuration")(
                    _vm.body.intervention_duration
                  ),
                  color: "success"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "mx-2",
                staticStyle: { width: "50%" },
                attrs: {
                  label: _vm.generateMessage("requests.actions.shifting"),
                  disabled: !_vm.isClosing,
                  outlined: "",
                  color: "success",
                  type: "number"
                },
                model: {
                  value: _vm.body.intervention_shifting,
                  callback: function($$v) {
                    _vm.$set(_vm.body, "intervention_shifting", $$v)
                  },
                  expression: "body.intervention_shifting"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c(
                "v-radio-group",
                {
                  staticStyle: { width: "50%" },
                  attrs: {
                    label:
                      _vm.generateMessage("requests.actions.remote") + " *",
                    disabled: !_vm.isClosing,
                    rules: [v => !!v || "Ce champ est obligatoire"]
                  },
                  model: {
                    value: _vm.body.remotly,
                    callback: function($$v) {
                      _vm.$set(_vm.body, "remotly", $$v)
                    },
                    expression: "body.remotly"
                  }
                },
                [
                  _c("v-radio", {
                    attrs: {
                      label: _vm.generateMessage("requests.actions.yes"),
                      color: "success",
                      value: "O"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-radio", {
                    attrs: {
                      label: _vm.generateMessage("requests.actions.no"),
                      color: "success",
                      value: "N"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-radio-group",
                {
                  staticStyle: { width: "50%" },
                  attrs: {
                    label: _vm.generateMessage("requests.actions.ended") + " *",
                    disabled: !_vm.isClosing,
                    rules: [v => !!v || "Ce champ est obligatoire"]
                  },
                  model: {
                    value: _vm.body.repaired,
                    callback: function($$v) {
                      _vm.$set(_vm.body, "repaired", $$v)
                    },
                    expression: "body.repaired"
                  }
                },
                [
                  _c("v-radio", {
                    attrs: {
                      label: _vm.generateMessage("requests.actions.yes"),
                      color: "success",
                      value: "1"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-radio", {
                    attrs: {
                      label: _vm.generateMessage(
                        "requests.actions.yes_continued"
                      ),
                      color: "success",
                      value: "2"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.body.repaired === "2"
            ? _c("v-select", {
                staticClass: "mx-2",
                staticStyle: { width: "50%" },
                attrs: {
                  items: _vm.reasonsToBeContinued,
                  "item-text": "short_name",
                  "item-value": "id",
                  disabled: !_vm.isClosing,
                  clearable: "",
                  rules: [
                    v =>
                      _vm.body.repaired !== "2" ||
                      !!v ||
                      "Ce champ est obligatoire"
                  ],
                  label: _vm.generateMessage("requests.actions.reason") + " *",
                  color: "success",
                  outlined: "",
                  dense: ""
                },
                on: { input: _vm.setComment },
                model: {
                  value: _vm.body.reason_to_be_continued,
                  callback: function($$v) {
                    _vm.$set(_vm.body, "reason_to_be_continued", $$v)
                  },
                  expression: "body.reason_to_be_continued"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("custom-text-area", {
            staticClass: "mx-2",
            attrs: {
              color: "success",
              maxCharacter: 200,
              disabled: !_vm.isClosing,
              errorTooLongMsg: "Maximun 200 caractères.",
              label: _vm.generateMessage("requests.actions.comment")
            },
            model: {
              value: _vm.body.report_comment,
              callback: function($$v) {
                _vm.$set(_vm.body, "report_comment", $$v)
              },
              expression: "body.report_comment"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }